import http from '@/assets/js/interceptor';
export function getDepartmentAndPerson () {
  return http.get('/v1/departments/all', { domainType: 'orgApi' });
}
export function getDepartment () {
  return http.get('/v1/departments/valid/flatTreeOrgan', { domainType: 'orgApi' });
}
export function getRoleInfo (departmentId) {
  return http.get(`/v1/role/roleTree/${departmentId}`, { domainType: 'orgApi' });
}
export function getDepartmentSelect () {
  return http.get('/v1/departments/valid/allOrgan', { domainType: 'orgApi' });
}
export function getAllUserByDepartment (departmentIds) {
  return http.get(`/v1/users/departmentIds/${departmentIds}`, { domainType: 'orgApi' });
}
